import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const LinkContainer = ({
  exact,
  to,
  label,
  onClick,
}) => (
  <LinkParent>
    <NavLink to={to} onClick={onClick} exact={exact} activeStyle={{ color: 'white' }} style={{ textDecoration: 'none', color: '#aec0f5', fontWeight: 500 }}>{label}</NavLink>
  </LinkParent>
);

LinkContainer.propTypes = {
  exact: PropTypes.bool.isRequired,
  to: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

LinkContainer.defaultProps = {
  to: '',
  onClick: () => {},
};

export default LinkContainer;

const LinkParent = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  font-family: 'Karla', sans-serif;
  margin-left: 40px;
  letter-spacing: 1px;
`;



// WEBPACK FOOTER //
// ./client/components/LinkContainer.js